'use strict';

angular.module('mobile-apps').controller('JiraConfigurationModalController', [
	'$rootScope',
    '$scope',
    'ModalData',
    'EntryMain',
    'MobileApps',
    'JiraApi',
    'Utilities',
    '$modalInstance',
    '$window',
    '$http',
    '$q',
    function (
    	$rootScope,
        $scope,
        ModalData,
        EntryMain,
        MobileApps,
		JiraApi,
        Utilities,
        $modalInstance,
        $window,
        $http,
        $q
    ) {

		$scope.savedData = {
			host: ModalData.jiraConfig.host || '',
			email: ModalData.jiraConfig.email || '',
			apiToken: ModalData.jiraConfig.apiToken || ''
		};

        $scope.data = {
            host: $scope.savedData.host || undefined,
            email: $scope.savedData.email || undefined,
            apiToken: $scope.savedData.apiToken || undefined,
			project: {},
            defaultIssueTypeId: undefined
        };

        $scope.projects = undefined;
        $scope.issueTypes = undefined;

        $scope.findProjects = function() {
            var sendData = {
                host: $scope.data.host,
                email: $scope.data.email,
                apiToken: $scope.data.apiToken
            };

			JiraApi.projects(sendData).$promise
                .then(
                    function(data) {
                        $scope.projects = data;
                    }
                )
                .catch(
                    function (error) {
                        Utilities.showMessageErrorResponse(error);
                    }
                );
        };

        $scope.findIssueTypes = function() {
            var sendData = {
                host: $scope.data.host,
                email: $scope.data.email,
                apiToken: $scope.data.apiToken
            };

			JiraApi.issueTypes(sendData).$promise
                .then(
                    function(data) {
						$scope.issueTypes = data.filter(function (issueType) {
							return ['Task', 'Bug', 'Story'].includes(issueType.name);
						});
                    }
                )
                .catch(
                    function (error) {
						Utilities.showMessageErrorResponse(error);
                    }
                );
        };


        $scope.saveJiraConfig = function() {
            var sendData = {
                mobileAppId: ModalData.mobileApp._id,
                host: $scope.data.host,
                projectId: $scope.data.project.id,
                projectKey: $scope.data.project.key,
                email: $scope.data.email,
                apiToken: $scope.data.apiToken,
                defaultIssueTypeId: $scope.data.defaultIssueTypeId
            };

			JiraApi.configure(sendData).$promise
                .then(
                    function(data) {
                        Utilities.showMessage('Success', 'Jira configuration saved!', 'success');
						$rootScope.$broadcast('addedJiraConfig');
                        $modalInstance.close({
                            success: true,
                            data: data
                        });
                    }
                )
                .catch(
                    function(error) {
						Utilities.showMessageErrorResponse(error);
                    }
                );
        };

		$scope.backToCredentials = function() {
			$scope.projects = undefined;
		};

		$scope.backToProjects = function() {
			$scope.issueTypes = undefined;
		};


        /**
         * Close modal
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    }
]);
